import { Navigate, Outlet, useLocation } from "react-router";
import { useAuthStore } from "@/store/useAuthStore";
import { useDailyReportMode } from "@/hooks/useFarmFeatures";

interface ProtectedRouteProps {
  requiredRoles?: string[];
}

export default function ProtectedRoute({
  requiredRoles,
}: ProtectedRouteProps) {
  const { isAuthenticated, isLoading, user } = useAuthStore();
  const isDailyReportMode = useDailyReportMode();
  const location = useLocation();

  if (isLoading) {
    return (
      // data-route-pending: nothing of the page is shown yet (see App.tsx).
      <div data-route-pending className="flex items-center justify-center h-screen">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-brand-500 border-t-transparent" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/signin" replace />;
  }

  // Admin should only access /system routes
  if (user?.role === "admin" && !requiredRoles?.includes("admin")) {
    return <Navigate to="/system" replace />;
  }

  if (requiredRoles && user && !requiredRoles.includes(user.role)) {
    return <Navigate to="/" replace />;
  }

  // Supervisor/manager in daily report mode: redirect root to /daily-report
  if (isDailyReportMode && location.pathname === "/") {
    return <Navigate to="/daily-report" replace />;
  }

  return <Outlet />;
}
